import { Skeleton } from 'primereact/skeleton';

export const APP_BASE_URL = 'https://api.karan-enterprise.com';
// export const APP_BASE_URL = 'http://127.0.0.1:8000';
export const ASSET_PATH = 'https://api.karan-enterprise.com';

export const IMAGE_BASEURL = APP_BASE_URL + 'front/assets/img/search_image.png';

// PAGINATION
//default pagination Row data
export const defaultRowOptions = 100;

//default PerPageRow options
export const defaultPageRowOptions = [10, 25, 50, 100, 250, 500];

//paginatior entries showing
export const showingEntries = 'Showing {first} to {last} of {totalRecords} Entries';

//paginator links & dropdown
export const paginatorLinks = 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown';

//emilPattern
export const emailPattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
);

//Date Convert To YYYY/MM/DD
export function convertDateFrom(date: any) {
    date = new Date(date); //Date pass
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    return year + '-' + (month <= 9 ? '0' + month : month) + '-' + (day <= 9 ? '0' + day : day);
}

// skeleton items & length
export const Skeletonitems: number[] = Array.from({ length: 10 }, (v, i) => i);

// SKELETON FOR COLUMN BODY
export function SkeletonbodyTemplate(): JSX.Element {
    return <Skeleton></Skeleton>;
}
